/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Modal, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import EmpProfile from '../../../../common/components/EmpProfile/EmpProfile';
import { fonts, themes } from '../../../../common/themes/themes';
import SearchComponent from '../../../../common/components/SearchComponent';
import _ from 'lodash';
import { DateField } from '../../../../components';
import {
  baseDateFormatting,
  baseDateTimeFormatting,
  baseTimeFormatting,
} from '../../../../common/helper';
import './DigitalSignature.css'
import ImageViewer from '../../../../common/components/ImageViewer/ImageViewer';

interface propMyTraining {
  trans?: any;
  i18n?: any;
  myViewLogsData: any;
  setCloseModal: (data: any) => void;
}
const ViewDigitalDocsPresenter: React.FC<propMyTraining> = ({
  myViewLogsData,
  trans,
  setCloseModal
}) => {

  const [openModal, closeModal] = useState(false)
  const [attachment, setAttachment] = useState(null)
  const handleViewAttachment = (attachment: any) => {
    setAttachment(attachment)
    closeModal(true)
  };
  const status = [
    { id: 1, name: 'Requested' },
    { id: 2, name: 'Saved' },
    { id: 3, name: 'Canceled' },
    { id: 4, name: 'Rejected' },
    { id: 5, name: 'Drafted' },
  ];
  return (
    <>
      <div >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <p>{trans('History')}</p>
          <i
            className="las la-times-circle"
            style={{ fontSize: '1.5rem', cursor: 'pointer' }}
            onClick={() => setCloseModal(false)}
          ></i>
        </div>
        <div className='border-box' style={{ maxHeight: '480px', overflow: 'auto' }}>
          <div>
            {
              _.map(myViewLogsData, (item, index) => {
                const changes = item?.changed_fields ? Object.entries(item.changed_fields) : [];
                return (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '0.25rem',
                      paddingTop: '0.5rem',
                      paddingBottom: '0.5rem',
                      boxSizing: 'border-box',
                      marginTop: '0.5rem',
                      marginBottom: '0.5rem',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', columnGap: '0.5rem' }}>
                      <img
                        src={item?.user_profile}
                        alt=""
                        style={{ width: '2.5rem', height: '2.5rem', borderRadius: '9999px' }}
                      />
                      <div>
                        <p style={{ color: '#7C0E6F', fontWeight: 500 }}>
                          {item?.updatedByName}
                          <span style={{ color: '#9CA3AF', marginLeft: '0.5rem', fontSize: '0.875rem' }}>
                            ({item?.action})
                          </span>
                        </p>
                        <p style={{ color: '#6B7280', fontSize: '0.875rem' }}>
                          Updated on <DateField value={item?.updated_at} format={baseDateTimeFormatting} />
                        </p>
                      </div>
                    </div>

                    {changes.length > 0 && (
                      <div style={{ marginLeft: '3rem', marginTop: '0.5rem' }}>
                        {changes.map(([field, value]: any, i) => {
                          let attachment = false;

                          const formatValue = (val: any) => {
                            if (field === 'Status') {
                              return status.find((stat) => stat?.id == val)?.name;
                            }
                            return val;
                          };

                          if (field === 'Attachment') {
                            attachment = true;
                          }

                          return attachment ? (
                            <p key={i} style={{ fontSize: '0.875rem', color: '#374151', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <span style={{ fontWeight: 500, textTransform: 'capitalize' }}>{field}</span>
                              {':'}
                              {value?.old && (
                                <>
                                  <i
                                    className="line-through las la-eye"
                                    style={{ color: '#EF4444', cursor: 'pointer', fontSize: '1.125rem', padding: '0 0.25rem' }}
                                    onClick={() => handleViewAttachment(formatValue(value?.old?.toString()))}
                                  ></i>
                                </>
                              )}
                              {value?.old && value?.new && '→'}
                              {value?.new && (
                                <i
                                  className="las la-eye"
                                  style={{ color: '#16A34A', fontSize: '1.125rem', cursor: 'pointer', padding: '0 0.25rem' }}
                                  onClick={() => handleViewAttachment(formatValue(value?.new?.toString()))}
                                ></i>
                              )}
                            </p>
                          ) : (
                            <p
                              key={i}
                              style={{
                                fontSize: '0.875rem',
                                color: '#374151',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                wordBreak: 'break-word',
                                width: '100%',
                              }}
                            >
                              <span style={{ fontWeight: 500, textTransform: 'capitalize', whiteSpace: 'nowrap' }}>{field}</span>
                              {':'}
                              {value?.old != null && value?.old != 0 && (
                                <span style={{ textDecoration: 'line-through', color: '#EF4444', padding: '0 0.25rem', whiteSpace: 'nowrap' }}>
                                  {formatValue(value?.old)}
                                </span>
                              )}
                              {value?.old != null && value?.new != null && value?.old != 0 && '→'}
                              {value?.new && (
                                <span style={{ color: '#16A34A', padding: '0 0.25rem', whiteSpace: 'nowrap' }}>
                                  {formatValue(value?.new)}
                                </span>
                              )}
                            </p>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
      <Modal open={openModal} onClose={() => closeModal(false)}>
        <ImageViewer
          url={attachment}
          pdf={true}
          onClose={()=>closeModal(false)}
        />
      </Modal>
    </>
  );
};
export default ViewDigitalDocsPresenter;
